export { UserInfo as default, UserInfo } from './UserInfo';
export type { UserInfoProps } from './UserInfo';